import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import "../Modal/Modal.css";
import { toast } from "react-toastify";

export default function SmsTemplateModal({ item, close }) {
  const [name, setName] = useState(item?.name);
  const [content, setContent] = useState(item?.content);
  const [status, setStatus] = useState(item?.status??1);
  const [cookies, setCookie, removeCookie] = useCookies();

  async function editHandle() {
    let url = Constants.apiUrl + "/api/sms/template/update";
    if (!item) {
      url = Constants.apiUrl + "/api/sms/template/store";
    }
    axios
      .post(
        url,
        {
          id: item?.id,
          name: name,
          content: content,
          status: status,
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      )
      .then((r) => {
        toast.success("عملیات با موفقیت انجام شد");
        close();
      })
      .catch((e) => {
        toast.error("خطا در انجام عملیات");
      });
  }

  return (
    <React.Fragment>
      <div className="location_modal text-right">
        <div className="location_modal_box">
          <div className="location_modal_header bg-dark p-2">
            <span className=" w-100 text-right text-white">ویرایش</span>
          </div>
          <div className="p-4 text-center">
            <p>نام</p>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <hr />
            <p>الگو</p>
            <textarea
              type="text"
              style={{direction:"rtl"}}
              className="form-control"
              onChange={(e) => {
                setContent(e.target.value);
              }}
            >
              {content}
            </textarea>
            <hr />
            <p>وضعیت</p>
            <select
              className="form-control"
              onChange={(e) => {
                setStatus(e.target.value);
              }}
            >
              <option value={1} selected={status == 1}>
                فعال
              </option>
              <option value={0} selected={status == 0}>
                غیر فعال
              </option>
            </select>
            <hr />
            <div className="row text-right my-3 " style={{ direction: "rtl" }}>
              <div className="col-12 text-center">
                <button
                  className="btn btn-success btn-block"
                  onClick={editHandle}
                >
                  ویرایش
                </button>
                <button className="btn btn-danger btn-block" onClick={close}>
                  انصراف
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
